<svg
    width="330"
    height="330"
    viewBox="0 0 330 330"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    [attr.class]="classes"
>
    <circle
        opacity="0.4"
        cx="158.125"
        cy="158.125"
        r="157.536"
        transform="rotate(93.2159 158.125 158.125)"
        [attr.fill]="color"
    />
</svg>
